module.exports = __webpack_public_path__ + "img/spartan-roof-replacement-waterproofing-06-med.a98b2b61.jpg";